import permissions from '../../permissions'

const SSO_CORPORATE_GROUP_LIST = [
  {
    name: permissions.PERMISSIONS_DEFAULT_LABEL.LIST,
    tag: permissions.SSO_CORPORATE_GROUP.LIST,
  },
  {
    name: permissions.PERMISSIONS_DEFAULT_LABEL.SHOW,
    tag: permissions.SSO_CORPORATE_GROUP.SHOW,
  },
  {
    name: permissions.PERMISSIONS_DEFAULT_LABEL.CREATE,
    tag: permissions.SSO_CORPORATE_GROUP.CREATE,
  },
  {
    name: permissions.PERMISSIONS_DEFAULT_LABEL.MANAGE,
    tag: permissions.SSO_CORPORATE_GROUP.EDIT,
  },
]

export default SSO_CORPORATE_GROUP_LIST
